import React, { useEffect } from 'react'
import './scrollup.css'

const Scrollup = () => {

 

    useEffect(() => {
        const handleScroll = () => {
          const scrollup = document.querySelector('.scrollup');
          if (window.scrollY >= 560) {
            scrollup.classList.add('show-scroll');
          } else {
            scrollup.classList.remove('show-scroll');
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        // Cleanup event listener on component unmount
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

  return (
    <a href="#" className="scrollup">
        <i className="uil uil-arrow-up scrollup__icon"></i>
    </a>
  )
}

export default Scrollup